import React from 'react';
import { useTranslation } from 'react-i18next';

import styled, { keyframes, css } from 'styled-components';

const animateOpacity = keyframes`
    0%, 100%{
        opacity: 1;
    } 
    50%{
        opacity: 0;
    }
`;

const Text = styled.div(
  ({ theme }) => css`
    animation: ${animateOpacity} 0.8s infinite;
    ${theme.textTypes['Subtitle-1-w500']}
    color: #707070;
    font-weight: 600;
    font-size: 14px;
    width: 100%;
    text-align: center;
    margin-bottom: 32px;
    margin-top: ${(props) => (props.mobile ? '0px' : '12px')};
    padding-bottom: 32px;
  `
);

const LoadingTransactions = ({ mobile }) => {
  const { t } = useTranslation();
  return <Text mobile={mobile}>{t('transactionsFalabella.loading')}</Text>;
};

export default LoadingTransactions;
